import BaseHotspot from "./BaseHotspot";

/**
 * Type of hotspot where the action is to open a link
 *
 * Functionality is now rolled into the media hotspot
 */
export default class WebHotspot extends BaseHotspot {
  /**
   * Initialises a web hotspot based on a config object.
   *
   * @param config
   *
   * @example
   * {
   *   u: 0,
   *   v: 0.5,
   *   type: 'web',
   *   icon: {
   *     name: 'Icon name',
   *     uuid: '...',
   *     url?: 'https://...'
   *   },
   *   options: {
   *     display: 'lightbox'
   *     url: 'http://google.com'
   *   }
   * }
   */
  constructor(player, config) {
    super(player, config);

    this.loadIcon(config.icon, "web-link.png");

    this._config = config;
  }

  // override setactive in case of lightbox
  setActive() {
    if (this._config.options?.display === "lightbox") {
      if (this._hasTooltip) this._tooltip.setVisibility(false);
      this._isActive = true;
      this.setOpacity(0);
    } else {
      setTimeout(() => this._setHover(false), 0);
    }
  }
}
